<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات واحد غذا"
        >
          <b-form
            ref="foodunitform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    cols="12"
                    class="mb-1"
                  >
                    <fm-file-select
                      v-model="Form.Image"
                      label="عکس"
                      :entity="1"
                    />
                  </b-col>
                  <b-col md="12" class="mb-1">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          rows="3"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1 mb-2">
                      <b-form-checkbox
                          v-model="Form.Visibility"
                          value="true"
                          name="Visibility"
                          class="custom-control-success"
                      >
                        به کاربر نمایش داده شود.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import FmFileSelect from '@/views/menu/file-manager/components/fmFileSelect.vue'

export default {
  name: 'FoodUnitDetails',
  components: {
    FmFileSelect,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        Visibility: false,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodunit.add
      if (this.$route.params.id) {
        url = this.$api.foodunit.update
      }

      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodunit.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>
